import { z } from 'zod'

export const conversationExplorerDateFieldSchema = z.enum([
  'updated',
  'created',
])

export type ConversationExplorerDateField = z.infer<
  typeof conversationExplorerDateFieldSchema
>

export const conversationExplorerWindowSchema = z.enum(['24h', '7d', '30d'])

export type ConversationExplorerWindow = z.infer<
  typeof conversationExplorerWindowSchema
>

const calendarDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/)

export const explorerFilterSearchSchema = z.object({
  convClusters: z.array(z.string()).optional().catch(undefined),
  convUsers: z.array(z.string()).optional().catch(undefined),
  convDateField: conversationExplorerDateFieldSchema
    .optional()
    .catch(undefined),
  convFrom: calendarDateSchema.optional().catch(undefined),
  convTo: calendarDateSchema.optional().catch(undefined),
  convWithin: conversationExplorerWindowSchema.optional().catch(undefined),
})

export type ExplorerFilterSearch = z.infer<typeof explorerFilterSearchSchema>

export const conversationExplorerSearchSchema =
  explorerFilterSearchSchema.extend({
    convSite: z.string().optional().catch(undefined),
    convId: z.string().optional().catch(undefined),
  })

export type ConversationExplorerSearch = z.infer<
  typeof conversationExplorerSearchSchema
>

export const CLEARED_EXPLORER_FILTERS = {
  convClusters: undefined,
  convUsers: undefined,
  convDateField: undefined,
  convFrom: undefined,
  convTo: undefined,
  convWithin: undefined,
} as const satisfies Record<keyof ExplorerFilterSearch, undefined>

interface ExplorerSiteState {
  conversationId: string | undefined
  filterSearch: ExplorerFilterSearch
}

export const EMPTY_EXPLORER_STATE: ExplorerSiteState = {
  conversationId: undefined,
  filterSearch: CLEARED_EXPLORER_FILTERS,
}

export const explorerStateForSite = (
  search: ConversationExplorerSearch,
  siteId: string
): ExplorerSiteState =>
  search.convSite === siteId
    ? {
        conversationId: search.convId,
        filterSearch: explorerFilterSearchSchema.parse(search),
      }
    : EMPTY_EXPLORER_STATE

export const explorerSearchFor = (
  siteId: string,
  state: ExplorerSiteState
): ConversationExplorerSearch => ({
  ...CLEARED_EXPLORER_FILTERS,
  ...state.filterSearch,
  convSite: siteId,
  convId: state.conversationId,
})
